import logo from '../assets/logo.svg';
import '../css/App.css';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import AboutUsPage from './pages/AboutUs';
import LandingPage from './pages/LandingPage';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ServicesPage from './pages/ServicesPage';
import WealthManagement from './pages/Services/WealthManagement';
import Taxation from './pages/Services/Taxation';
import Mortgages from './pages/Services/Mortgages';
import SavingsAndInvestments from './pages/Services/SavingsAndInvestments';
import Protection from './pages/Services/Protection';
import EquityRelease from './pages/Services/EquityRelease';
import CalculatorsPage from "./pages/calculators/MortgageBorrowPage";
import ContactUsPage from './pages/ContactUsPage';
import FAQsPage from './pages/FAQsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import MortgageBorrowCalculatorsPage from './pages/calculators/MortgageBorrowPage';
import MortgageRepaymentCalculatorsPage from './pages/calculators/MortgageRepaymentPage';
import MortgageOverpaymentCalculatorsPage from './pages/calculators/OverpaymentPage';
import StampDutyPage from './pages/calculators/StampDutyPage';
import HowMuchWillItCostPage from './pages/calculators/HowMuchWillItCostPage';
import HowMuchCanIBorrowCalculator from './calculators/HowMuchCanIBorrowCalculator';
import HowMuchCanIBorrowPage from './pages/calculators/HowMuchCanIBorrowPage';
import EquityReleasePage from './pages/calculators/EquityReleasePage';
import RelevantLifeTaxPage from './pages/calculators/RelevantLifeTaxPage';
import PensionShortfallPage from './pages/calculators/PensionShortfallPage';
import InheritanceTaxPage from "./pages/calculators/InheritanceTaxPage";
import InvestmentPage from "./pages/calculators/InvestmentPage";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/*" element={<LandingPage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route
            path="/services/wealth-management"
            element={<WealthManagement />}
          />
          <Route path="/services/taxation" element={<Taxation />} />
          <Route path="/services/mortgages" element={<Mortgages />} />
          <Route
            path="/services/savings-investments"
            element={<SavingsAndInvestments />}
          />
          <Route path="/services/protection" element={<Protection />} />
          <Route path="/services/equity-release" element={<EquityRelease />} />
          <Route path="/contact-us" element={<ContactUsPage />} />
          <Route path="/faqs" element={<FAQsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route
            path="/calculators/mortgage-borrow"
            element={<MortgageBorrowCalculatorsPage />}
          />
          <Route
            path="/calculators/mortgage-repayment"
            element={<MortgageRepaymentCalculatorsPage />}
          />
          <Route
            path="/calculators/overpayment"
            element={<MortgageOverpaymentCalculatorsPage />}
          />
          <Route path="/calculators/stamp-duty" element={<StampDutyPage />} />
          <Route
            path="/calculators/how-much-will-it-cost"
            element={<HowMuchWillItCostPage />}
          />
          <Route
            path="/calculators/how-much-can-i-borrow"
            element={<HowMuchCanIBorrowPage />}
          />
          <Route
            path="/calculators/equity-release"
            element={<EquityReleasePage />}
          />
          <Route
            path="/calculators/relevant-life-tax"
            element={<RelevantLifeTaxPage />}
          />
          <Route
            path="/calculators/pensions-shortfall"
            element={<PensionShortfallPage />}
          />
          <Route
            path="/calculators/inheritance-tax"
            element={<InheritanceTaxPage />}
          />
          <Route path="/calculators/investment" element={<InvestmentPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
